<template>
  <div>
    <contract-list :contractStage="1" ref="list" :buttonPriviledgeList="buttonPriviledgeList" v-show="formStatus == 'list'" v-if="success" @addCallback="handleAdd" @changeCallback="handleChange" @viewCallback="handleView"></contract-list>
    <contract-add v-if="formStatus == 'add'" :buttonPriviledgeList="buttonPriviledgeList" :addInfo="addInfo" @formCallback="handleFormStatus"></contract-add>
    <contract-change v-if="formStatus == 'change'" :buttonPriviledgeList="buttonPriviledgeList" :changeInfo="itemInfo" @formCallback="handleFormStatus"></contract-change>
    <contract-view v-if="formStatus == 'view'" :buttonPriviledgeList="buttonPriviledgeList" :viewInfo="itemInfo" @formCallback="handleFormStatus"></contract-view>
  </div>
</template>

<script>
import ContractList from "@/views/erp/contract/ContractList";
import ContractAdd from "@/views/erp/contract/ContractAdd";
import ContractChange from "@/views/erp/contract/ContractChange";
import ContractView from "@/views/erp/contract/ContractView";
import {default as PermissionApi} from "@/api/smp/auth/Permission";
export default {
  name: "Erp-Expend-Contract",
  components: {ContractView, ContractChange, ContractList, ContractAdd},
  props: {
    page: {
      type: Object,
      default: null,
    }
  },
  data(){
    return {
      formStatus:'list',
      addInfo:{},
      itemInfo:{},
      success:false,
      buttonPriviledgeList: [],
    }
  },
  created() {
    this.getButtonPriviledge()
  },
  methods:{
    getButtonPriviledge(){
      console.log('this.page',this.page)
      let menuId = this.page.id
      let me = this
      PermissionApi.queryButtonPriviledge(menuId,null).then(resp=>{
        PermissionApi.handleResponse(resp, me, function (data){
          me.buttonPriviledgeList = data.buttonPriviledges
          me.success = true;
          console.log('buttonPriviledgeList',me.buttonPriviledgeList)
        })
      })
    },
    handleAdd(data){
      this.formStatus = 'add';
      this.addInfo = data;
    },
    handleFormStatus(formStatus){
      this.formStatus = formStatus
      if(formStatus == 'list'){
        this.$refs.list.getDataFromApi();
      }
    },
    handleChange(data){
      this.formStatus = 'change';
      this.itemInfo = data;
    },
    handleView(data){
      this.formStatus = 'view';
      this.itemInfo = data;
    }
  }
}
</script>

<style scoped>

</style>